function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from "react";
import _ from "lodash";
import { DndProvider } from "react-dnd-multi-backend";
import HTML5toTouch from "react-dnd-multi-backend/dist/esm/HTML5toTouch";
import DragItem from "./DragItem.js";
import DropZone from "./DropZone.js";
import { CustomDragLayer } from "./CustomDragLayer.js";
import { processStyles, withSCORM } from "igloo-common/src/utils";
import "igloo-common/src/styles-common.scss";
import "./styles.scss";
export var withDragDropContext = function withDragDropContext(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(DndProvider, {
      options: HTML5toTouch
    }, /*#__PURE__*/React.createElement(Component, props));
  };
};

var DragAndDrop = /*#__PURE__*/function (_Component) {
  _inherits(DragAndDrop, _Component);

  var _super = _createSuper(DragAndDrop);

  function DragAndDrop(props) {
    var _this;

    _classCallCheck(this, DragAndDrop);

    _this = _super.call(this, props);
    _this.state = {
      config: props.config,
      totalCompleted: 0,
      totalDrops: 0,
      totalItems: props.config.items.length,
      dragItems: [],
      dropZones: [],
      resets: 0
    };

    _this.props.initSCORM();

    return _this;
  }

  _createClass(DragAndDrop, [{
    key: "dropHandler",
    value: function dropHandler() {
      this.setState({
        totalCompleted: this.state.totalCompleted + 1,
        gameStarted: true
      });

      if (this.state.totalCompleted == this.state.totalItems) {
        this.props.completeInteraction("matching", "correct");
        this.props.completeObjective("0", "100", "100", "completed");
        this.props.save();
      }
    }
  }, {
    key: "dropAttempt",
    value: function dropAttempt() {
      this.setState({
        totalDrops: this.state.totalDrops + 1
      });
    }
  }, {
    key: "generateReview",
    value: function generateReview() {
      var review = [];

      _.each(this.state.config.items, function (item, idx) {
        review.push( /*#__PURE__*/React.createElement("li", {
          key: idx
        }, item.drag.text, " - ", item.drop.text));
      });

      return review;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.setState({
        totalCompleted: 0,
        totalDrops: 0,
        gameStarted: false,
        dragItems: [],
        dropZones: [],
        resets: this.state.resets + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dragItems = [];
      var dropZones = [];
      var designOptions = this.state.config.design;
      var maxWidth = parseInt(designOptions.width * 2) + parseInt(designOptions.gutter);

      if (!this.state.gameStarted || this.props.editor) {
        _.each(this.state.config.items, function (item, idx) {
          item.drag.attributes.maxWidth = designOptions.width;
          item.drag.attributes.height = designOptions.height;
          item.drag.attributes.borderRadius = designOptions["border-radius"];
          item.drag.attributes.fontSize = designOptions["font-size"];
          item.drop.attributes.maxWidth = designOptions.width;
          item.drop.attributes.height = designOptions.height;
          item.drop.attributes.borderRadius = designOptions["border-radius"];
          item.drop.attributes.fontSize = designOptions["font-size"];
          var dropZone = /*#__PURE__*/React.createElement(DropZone, {
            dropHandler: _this2.dropHandler.bind(_this2),
            style: processStyles(item.drop.attributes),
            key: idx,
            name: item.drop.text,
            allow_item: idx
          });
          var dragItem = /*#__PURE__*/React.createElement(DragItem, {
            style: processStyles(item.drag.attributes),
            key: idx,
            dropAttempt: _this2.dropAttempt.bind(_this2),
            name: item.drag.text,
            ref: function ref(element) {
              return _this2.element = element;
            },
            item_id: idx
          });
          dragItems.push(dragItem);
          dropZones.push(dropZone);
        });

        if (this.state.config.options.shuffle_drag_items && !this.state.gameStarted && !this.props.editor) {
          dragItems = _.shuffle(dragItems);
        }

        if (this.state.config.options.shuffle_drop_items && !this.props.editor) {
          dropZones = _.shuffle(dropZones);
        }

        this.state.gameStarted = true;
        this.state.dropZones = dropZones;
        this.state.dragItems = dragItems;
      }

      if (this.state.totalCompleted == this.state.totalItems) {
        var review = null;

        if (this.state.config.options.show_review) {
          review = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, "Let's Review:"), /*#__PURE__*/React.createElement("ul", null, this.generateReview()));
        }

        var resetButton = null;

        if (this.state.config.options.show_retry) {
          resetButton = /*#__PURE__*/React.createElement("button", {
            className: "btn btn-link",
            onClick: function onClick() {
              return _this2.reset();
            }
          }, "Click here to play the game again");
        }

        return /*#__PURE__*/React.createElement("div", {
          className: "gameo-dnd",
          style: {
            maxWidth: maxWidth
          }
        }, /*#__PURE__*/React.createElement("h1", {
          dangerouslySetInnerHTML: {
            __html: this.state.config.content.completion_text
          }
        }), review, resetButton);
      }

      var totalDrops = null;

      if (this.state.config.options.show_drops) {
        totalDrops = /*#__PURE__*/React.createElement("div", {
          style: {
            marginBottom: 40
          }
        }, /*#__PURE__*/React.createElement("h5", null, "Drops: ", this.state.totalDrops));
      }

      return /*#__PURE__*/React.createElement("div", {
        id: "gameo",
        className: "gameo-dnd"
      }, /*#__PURE__*/React.createElement(CustomDragLayer, null), /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.state.config.content.intro_text
        }
      }), totalDrops, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          maxWidth: maxWidth
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-6 gameo-dnd-drag-items",
        style: {
          paddingRight: this.state.config.design.gutter / 2 + "px"
        }
      }, this.state.dragItems), /*#__PURE__*/React.createElement("div", {
        className: "col-6 gameo-dnd-drop-zones",
        style: {
          paddingLeft: this.state.config.design.gutter / 2 + "px"
        }
      }, this.state.dropZones)));
    }
  }]);

  return DragAndDrop;
}(Component);

export default withSCORM(withDragDropContext(DragAndDrop));